<template>
  <div>
    <el-input
        class="search-el"
        size="mini"
        v-model="query.title"
        clearable
        placeholder="请输入标题"
    ></el-input>
    <el-select
        class="search-el"
        size="mini"
        v-model="query.banner_item_id"
        placeholder="请选择轮播图位置"
        clearable
    >
      <el-option label="全部" value=""></el-option>
      <el-option
          v-for="(v, k) in bannerItemList"
          :key="k"
          :label="v"
          :value="k"
      >
      </el-option>
    </el-select>
    <el-select
        class="search-el"
        size="mini"
        v-model="query.status"
        clearable
        placeholder="状态"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="已发布" value="1">已发布</el-option>
      <el-option label="未发布" value="2">未发布</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加</el-button>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column
            prop="id"
            label="ID"
            align="center"
            min-width="3%"
        ></el-table-column>
        <el-table-column label="标题" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.image" style="width: 66px; height: 28px;" alt=""/>
          </template>
        </el-table-column>

        <el-table-column label="位置" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <div>{{ filterBannerItem(row.banner_item_id) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="跳转目标" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <div>{{ filterBannerTarget(row.target) }}</div>
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
            prop="created_at"
            label="创建时间"
            align="center"
            min-width="12%"
        ></el-table-column>

        <el-table-column label="显示时间" width="150">
          <template slot-scope="{row}">
            <span v-if="row.display_start_time!=null">{{ row.display_start_time }}~{{ row.display_end_time }}</span>
            <span v-else></span>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a"
              ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399"
              ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                  type="text"
                  size="small"
                  style="margin-left: 5px"
                  @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getBannerItemList,
  getBannerTargetList,
  getList,
  updateStatus,
  del,
  updateSort,
} from "@/api/banner";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      bannerItemList: [],
      bannerTargetList: [],
      total: 0,
      query: {
        page: 1,
        limit: 10,
        title: "",
        banner_item_id: "",
        status: "",
      },
    };
  },
  created: function () {
    if (typeof this.$route.query.banner_item_id != "undefined" && this.$route.query.banner_item_id != '') {
      this.query.banner_item_id = this.$route.query.banner_item_id
    }
    getBannerItemList().then((response) => {
      this.bannerItemList = response.data;
    });
    getBannerTargetList().then((response) => {
      this.bannerTargetList = response.data;
    });
    this.getList();
  },
  methods: {
    filterBannerItem(id) {
      return this.bannerItemList[id];
    },
    filterBannerTarget(target) {
      return this.bannerTargetList[target];
    },

    toCreate(id) {
      this.$router.push({
        path: "/banner/info",
        query: {
          id: id,
        },
      });
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
          .then(({value}) => {
            updateSort({
              id: id,
              sort: value,
            }).then((response) => {
              if (response.status == 2000) {
                this.getList();
                this.$message({
                  showClose: true,
                  message: "设置成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
          });
    },

    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        }
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {
  },
};
</script>

<style>
</style>